var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-actions-menu"},[_c('v-btn',{staticClass:"list-card-main d-flex",attrs:{"ripple":false,"x-large":"","color":"primary","depressed":""},on:{"click":_vm.redirect}},[_vm._v(" "+_vm._s(_vm.$t('tableElementRedirectBtn.redirect-to-old'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }